<template>
  <svg :width="width"
       :height="height"
       viewBox="0 0 275 275"
  >
    <path :fill="color" class="cls-1" d="M36.84,90.3A17.56,17.56,0,1,0,19.29,72.73,17.54,17.54,0,0,0,36.84,90.3Z"/>
    <path :fill="color" class="cls-1" d="M141.45,112.66a34.94,34.94,0,1,0-34.92-34.92A35,35,0,0,0,141.45,112.66Zm0-51.36A16.41,16.41,0,1,1,125,77.74,16.44,16.44,0,0,1,141.45,61.3Z"/>
    <path :fill="color" class="cls-1" d="M155.86,131a32.6,32.6,0,1,0,32.6,32.6A32.6,32.6,0,0,0,155.86,131Z"/>
    <path :fill="color"  class="cls-1" d="M112.56,136a29.22,29.22,0,1,0-29.21,29.23A29.23,29.23,0,0,0,112.56,136Zm-48,0a18.82,18.82,0,1,1,18.82,18.81A18.83,18.83,0,0,1,64.53,136Z"/>
    <path :fill="color"  class="cls-1" d="M209.06,60.71A13.71,13.71,0,1,0,195.35,47,13.69,13.69,0,0,0,209.06,60.71Z"/>
    <path :fill="color"  class="cls-1" d="M103.85,204.74a27.71,27.71,0,1,0,27.72,27.69A27.73,27.73,0,0,0,103.85,204.74Zm0,39.71a12,12,0,1,1,12-12A12,12,0,0,1,103.85,244.45Z"/>
    <path :fill="color"  class="cls-1" d="M42.8,177a16.37,16.37,0,1,0,16.35,16.37A16.35,16.35,0,0,0,42.8,177Z"/>
    <path :fill="color"  class="cls-1" d="M88.47,48.21a21,21,0,1,0-21-21A21,21,0,0,0,88.47,48.21Zm0-30.81a9.85,9.85,0,1,1-9.86,9.83A9.88,9.88,0,0,1,88.47,17.4Z"/>
    <path :fill="color"  class="cls-1" d="M242.22,75.31a25.55,25.55,0,1,0,25.54,25.53A25.55,25.55,0,0,0,242.22,75.31Zm0,37.56a12,12,0,1,1,12-12A12,12,0,0,1,242.22,112.87Z"/>
    <path :fill="color"  class="cls-1" d="M235.41,154.4a17.53,17.53,0,1,0,17.51,17.51A17.53,17.53,0,0,0,235.41,154.4Z"/>
    <path :fill="color"  class="cls-1" d="M209.78,194.29a14.5,14.5,0,1,0,14.5,14.46A14.51,14.51,0,0,0,209.78,194.29Zm0,21.31a6.82,6.82,0,1,1,6.82-6.85A6.83,6.83,0,0,1,209.78,215.6Z"/>
    <path :fill="color"  class="cls-1" d="M169.56,217.86A15.46,15.46,0,1,0,185,233.32,15.49,15.49,0,0,0,169.56,217.86Z"/>
    <path :fill="color"  class="cls-1" d="M35.63,132.12a14.79,14.79,0,1,0-14.79,14.75A14.82,14.82,0,0,0,35.63,132.12ZM20.84,139a6.94,6.94,0,1,1,7-6.92A6.94,6.94,0,0,1,20.84,139Z"/>
    <path :fill="color"  class="cls-1" d="M163.16,35.9a14.5,14.5,0,1,0-14.49-14.49A14.52,14.52,0,0,0,163.16,35.9Zm0-21.31a6.8,6.8,0,1,1-6.81,6.82A6.81,6.81,0,0,1,163.16,14.59Z"/>
    <path :fill="color"  class="cls-1" d="M80,69.93A10.64,10.64,0,1,0,90.68,80.59,10.64,10.64,0,0,0,80,69.93Z"/>
    <path :fill="color"  class="cls-1" d="M82.93,200.68a10.88,10.88,0,1,0-10.87-10.89A10.88,10.88,0,0,0,82.93,200.68Z"/>
    <path :fill="color"  class="cls-1" d="M208.09,148.88a14.5,14.5,0,1,0-14.5-14.5A14.51,14.51,0,0,0,208.09,148.88Zm0-21.31a6.8,6.8,0,1,1-6.8,6.81A6.82,6.82,0,0,1,208.09,127.57Z"/>
    <path :fill="color"  class="cls-1" d="M208.68,91.38A10.65,10.65,0,1,0,198,102,10.65,10.65,0,0,0,208.68,91.38Z"/>
  </svg>
</template>

<script>
export default {
  name: 'LogoNoText',
  props: {
    color: {
      type: String,
      required: true
    },
    width: {
      required: false,
      default: ''
    },
    height: {
      required: false,
      default: ''
    }
  }
}
</script>

<style scoped>

</style>
